// extracted by mini-css-extract-plugin
export default {"melodyVideo":"gL-z","isFullWidth":"hL-z","landingPageVideo":"iL-z","play":"jL-z","iframeVideo":"kL-z","playHidden":"lL-z","fullwidth":"mL-z"};